module.exports = __webpack_public_path__ + "static/media/link.992030c6.svg";